module.exports = __webpack_public_path__ + "static/media/bfile-rent.0a874ea4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-rent.svg
// module id = 3120
// module chunks = 0